export default {"src":"/_next/static/media/bybit-wallet.8b76c523.svg","height":88,"width":88};